import axios from  "axios";

const api = axios.create({
    // baseURL: "http://192.168.1.104:8000/api",
    baseURL: "https://commando-api.hkmhub.com/api",

});


// Fonction pour récupérer les données de l'utilisateur connecté
export const getUserInfo = async (token) => {
    try {
      const response = await api.get('/user', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;  // Retourne les données utilisateur
    } catch (error) {
      console.error('Erreur lors de la récupération des données utilisateur:', error);
      throw error;
    }
  };

export default api;
